import * as React from 'react';

export const useElementVisibilityById = (elementId: string, options: IntersectionObserverInit = {}): boolean => {
  const [isVisible, setIsVisible] = React.useState(false);
  const observer = React.useRef<IntersectionObserver | null>(null);

  React.useEffect(() => {
    const element = document.getElementById(elementId);

    if (!element) {
      setIsVisible(false);
      return;
    }

    const defaultOptions: IntersectionObserverInit = {
      threshold: 0.1,
      ...options,
    };

    observer.current = new IntersectionObserver((entries) => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
    }, defaultOptions);

    observer.current.observe(element);

    return () => {
      observer.current?.disconnect();
    };
  }, [elementId, options]);

  return isVisible;
};
